import toast from 'react-hot-toast'

export const toasterOptions = {
  duration: 2800,
  style: {
    background: '#000000',
    color: '#FFFFFF',
    border: '1px solid rgba(255, 255, 255, 0.14)',
    borderRadius: '10px',
    fontSize: '13px',
    fontWeight: 500,
  },
  success: {
    iconTheme: {
      primary: '#4ade80',
      secondary: '#000000',
    },
  },
}

export const appToast = {
  success: (message) => toast.success(message),
  error: (message) => toast.error(message),
  info: (message) => toast(message),
  approved: (title) => toast.success(`Approved: ${title}`),
  actionTriggered: (label) => toast.success(`${label} action triggered`),
}
